import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    applicantId: string;
};

export const schemaLoanRequestResolver_IsApplicantDataProtectionAgreed = z.boolean();

export type SchemaLoanRequestResolver_IsApplicantDataProtectionAgreed = z.infer<
    typeof schemaLoanRequestResolver_IsApplicantDataProtectionAgreed
>;

export type LoanRequestResolver_IsApplicantDataProtectionAgreed = Resolver<
    Arguments,
    SchemaLoanRequestResolver_IsApplicantDataProtectionAgreed
>;
